import React, { useEffect, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet'

import AuthImage from '../images/auth-image.jpg';
import SignInImage from '../images/sign-in.jpg';
import SignInImage2 from '../images/sign-in.gif';
import EmPushyLogo from '../images/empushy_logo_black.png';
import AuthDecoration from '../images/auth-decoration.png';

import { Auth } from "aws-amplify";
import { AmplifyAuthenticator, AmplifySignIn, AmplifySignUp,
    AmplifyGoogleButton} from '@aws-amplify/ui-react';
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';

function Signin() {

  const [authState, setAuthState] = useState(false);
  const [user, setUser] = useState(false);

  useEffect(() => {
      return onAuthUIStateChange((nextAuthState, authData) => {
          setAuthState(nextAuthState);
          setUser(authData)
      });
  }, []);

  return authState === AuthState.SignedIn && user ? (
    <Redirect to='/' />
  ) : (
    <main className="bg-yellow-300 overflow-hidden max-h-screen">
      {/* Page Title */}
      <Helmet>
        <title>EmPushy | Sign In</title>
      </Helmet>

      <div className="relative md:flex">

        {/* Content */}
        <div className="md:w-1/2">
          <div className="max-w-sm mx-auto min-h-screen flex flex-col justify-center px-4 py-8">

            <div className="w-full max-h-screen">
              {/*<h1 className="text-3xl text-gray-800 font-bold text-center">Welcome back! ✨</h1>*/}
                <AmplifyAuthenticator usernameAlias="email">
                    <div slot="sign-in">
                        <AmplifySignIn usernameAlias="email" >
                            <div slot="federated-buttons">
                                <AmplifyGoogleButton onClick={() => Auth.federatedSignIn({
                                    provider: "Google"
                                })} />
                                {/*<AmplifyFacebookButton onClick={() => Auth.federatedSignIn({
                                    provider: "Facebook"
                                })} />*/}
                                <hr className="my-2"/>
                            </div>
                        </AmplifySignIn>
                    </div>
                    <div slot="sign-up">
                        <AmplifySignUp
                            usernameAlias="email"
                            formFields={[
                                {
                                    type: "email",
                                    label: "Email",
                                    placeholder: "email@example.com",
                                    inputProps: { required: true, autocomplete: "username" },
                                },
                                {
                                    type: "password",
                                    label: "Password",
                                    placeholder: "password",
                                    inputProps: { required: true, autocomplete: "new-password" },
                                }
                            ]}>
                        </AmplifySignUp>
                    </div>
                </AmplifyAuthenticator>
              {/*<AmplifyAuthenticator
                  usernameAlias="email"
                  federated={{}}>
                <AmplifySignUp
                  slot="sign-up"
                  usernameAlias="email"
                  formFields={[
                    {
                      type: "email",
                      label: "Email",
                      placeholder: "email@example.com",
                      inputProps: { required: true, autocomplete: "username" },
                    },
                    {
                      type: "password",
                      label: "Password",
                      placeholder: "password",
                      inputProps: { required: true, autocomplete: "new-password" },
                    }
                  ]}/>
                <AmplifySignIn slot="sign-in" usernameAlias="email" />
                <AmplifySignIn slot="federated-buttons">
                  <AmplifyGoogleButton onClick={alert} />
                  <button onClick={() => Auth.federatedSignIn()}>
                      Custom Sign In
                  </button>
                  <hr />
                </AmplifySignIn>
              </AmplifyAuthenticator>*/}
            </div>

          </div>
        </div>

        {/* Image */}
        <div className="hidden md:block absolute top-0 bottom-0 right-0 md:w-1/2" aria-hidden="true">

            <div className="absolute mt-16 left-1/4 content-center">
                <img  src={EmPushyLogo} className="ml-4" width="300" height="300" viewBox="0 0 250 250" alt="Logo" />
            </div>
          {/*<img className="object-cover object-center w-full h-full" src={SignInImage} width="760" height="760" alt="Authentication" />*/}
          <img className="object-cover object-center w-full h-full" src={SignInImage2} width="500" height="500" alt="Authentication" />
          <img className="absolute top-1/4 left-0 transform -translate-x-1/2 ml-1" src={AuthDecoration} width="218" height="224" alt="Authentication decoration" />
        </div>

      </div>

    </main>
  );
}

export default Signin;